<!--
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-05-28 15:35:10
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-11 16:53:46
 * @FilePath: /pegasus-web-vehicle/src/components/BaseComponents/BaseForm/BaseFormItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="base-form-content">
    <form-item
      v-for="(it, index) in list"
      :ref="it.itemConfig && it.itemConfig.ref"
      :it="it"
      :model="model"
      :key="'it' + it.itemConfig.prop + index"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseFormItem',
  props: ['list', 'model'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.base-form-content {
  display: flex;
  flex-wrap: wrap;
}
</style>
